import {
  getJson,
  putJson,
  postJson,
  patchJson
} from '../fetch';
import { stringifyURLParams } from '../util';
import API_BASE_PATH from './basePath';

export const getSurveySchemas = (page, size, statuses) => {
  const params = stringifyURLParams({
    page, size, statuses: statuses && statuses.length ? statuses.join(',') : undefined
  });

  return getJson(`${API_BASE_PATH}/survey-schemas?${params}`);
};

export const getSurveySchema = (id) => getJson(`${API_BASE_PATH}/survey-schemas/${id}`);

export const postSurveySchema = (data) => postJson(`${API_BASE_PATH}/survey-schemas`, data);

export const putSurveySchema = (schemaId, data) => putJson(`${API_BASE_PATH}/survey-schemas/${schemaId}`, data);

export const patchSurveySchemaFeedbackIntroduction = (schemaId, data) => patchJson(`${API_BASE_PATH}/survey-schemas/${schemaId}`, data);

export const postSchemaVersion = (schemaId, data) => postJson(`${API_BASE_PATH}/survey-schemas/${schemaId}/versions`, data);

export const getOrCheckSurveySchemaCode = (suggestion) => {
  let requestUrl = 'survey-schemas/codes';
  if (suggestion) {
    requestUrl = `${requestUrl}?suggestion=${suggestion}`;
  }
  return getJson(`${API_BASE_PATH}/${requestUrl}`);
};
